import { createAtom } from '../utils';

export const showLiveWebinarAtom = createAtom<boolean>('showLiveWebinar', true);

export const liveWebinarEventIdFromUrlAtom = createAtom<string>(
  'liveWebinarEventIdFromUrlAtom',
  '',
);
